import React, { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import ItemCategoryCreateView from '../../../components/inventory/setup/item_category/ItemCategoryCreateView';
import ItemCategoryListView from '../../../components/inventory/setup/item_category/ItemCategoryListView';

const ItemCategoryCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.InventoryURL + 'inventory/product/sub/category/create/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const { data: data_cate, loading:loading_cate, error:error_cate, refetch:reload_cate } = useFetchData(AppURL.InventoryURL+"inventory/product/master/options/list/view/");
    const handleFormSuccess = (): void => {
        refetch();
    };
    
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ItemCategoryCreateView loading={loading_cate} data={data_cate} handleFormSuccess={handleFormSuccess} />
                </Grid>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ItemCategoryListView data={data_cate} handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} results={data} error={error} loading={loading} />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default ItemCategoryCreateListView